/* Jeelow Atelier — theme.js (no dependencies) */
(() => {
  const A = window.Atelier || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const money = (cents) => {
    const fmt = A.moneyFormat || '${{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, two);
  };

  /* ---------------------------------------------------------------
     Adaptive image fit
     For frames whose ratio differs from the photo's, sample the edge
     strip that would sit next to the fill. Plain background -> show the
     whole photo (contain) on a fill of that exact color; busy background
     (lifestyle shot) -> cover from the focal point.
  --------------------------------------------------------------- */
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  const SAMPLE = 40;

  function analyse(img, frame) {
    const edge = frame.dataset.edge; // 'x' = bars left/right, 'y' = bars top/bottom
    try {
      canvas.width = SAMPLE; canvas.height = SAMPLE;
      ctx.drawImage(img, 0, 0, SAMPLE, SAMPLE);
      const d = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
      const px = [];
      const push = (x, y) => { const i = (y * SAMPLE + x) * 4; px.push([d[i], d[i + 1], d[i + 2]]); };
      for (let k = 0; k < SAMPLE; k++) {
        for (let t = 0; t < 2; t++) {
          if (edge === 'x') { push(t, k); push(SAMPLE - 1 - t, k); }
          else { push(k, t); push(k, SAMPLE - 1 - t); }
        }
      }
      const mean = [0, 1, 2].map((c) => px.reduce((s, p) => s + p[c], 0) / px.length);
      let close = 0, varSum = 0;
      for (const p of px) {
        const dist = Math.hypot(p[0] - mean[0], p[1] - mean[1], p[2] - mean[2]);
        varSum += dist * dist;
        if (dist < 14) close++;
      }
      const sd = Math.sqrt(varSum / px.length);
      const uniform = close / px.length > 0.9 && sd < 10;
      if (uniform) {
        frame.style.setProperty('--fill', `rgb(${mean.map(Math.round).join(',')})`);
        frame.dataset.fit = 'contain';
      } else {
        // busy background: crop if the loss is modest, otherwise show the whole
        // photo over a soft blurred copy of itself (no heavy crops)
        const r = img.naturalWidth / img.naturalHeight;
        const f = frame.clientWidth / Math.max(1, frame.clientHeight);
        const lost = r > f ? 1 - f / r : 1 - r / f;
        if (lost > 0.3) {
          frame.style.setProperty('--blur-src', `url("${img.currentSrc || img.src}")`);
          frame.dataset.fit = 'blur';
        } else {
          frame.dataset.fit = 'cover';
        }
      }
    } catch (e) {
      frame.dataset.fit = 'cover';
    }
  }

  function onImg(img) {
    const done = () => {
      img.classList.add('is-loaded');
      const frame = img.closest('.media');
      if (frame && frame.dataset.fit === 'auto' && A.adaptiveFit !== false) analyse(img, frame);
    };
    if (img.complete && img.naturalWidth) done();
    else img.addEventListener('load', done, { once: true });
  }
  const initImages = (root = document) => $$('.media img', root).forEach(onImg);

  /* ---------------- drawers & overlays ---------------- */
  let lastFocus = null;
  function openEl(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    const f = el.querySelector('input[type=search], button, a[href], input');
    f && f.focus({ preventScroll: true });
  }
  function closeEl(el) {
    if (!el) return;
    el.hidden = true;
    if (!$$('.drawer:not([hidden]), .search-overlay:not([hidden])').length) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openEl($('#MenuDrawer')); }
    else if (t.closest('[data-open-filters]')) { e.preventDefault(); openEl($('#FilterDrawer')); }
    else if (t.closest('[data-open-search]')) { e.preventDefault(); openEl($('#SearchOverlay')); }
    else if (t.closest('[data-open-cart]') && A.cartDrawer) { e.preventDefault(); openCart(); }
    else if (t.closest('[data-close-drawer]')) { closeEl(t.closest('.drawer')); }
    else if (t.closest('[data-close-search]')) { closeEl($('#SearchOverlay')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer:not([hidden]), .search-overlay:not([hidden])').forEach(closeEl);
    const lb = $('.lightbox'); lb && lb.remove();
  });

  /* ---------------- announcement rotator ---------------- */
  $$('[data-rotator]').forEach((r) => {
    const items = $$('.announce__item', r);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------------- tabs ---------------- */
  $$('[data-tabs]').forEach((sec) => {
    const tabs = $$('[data-tab]', sec);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
      $$('[role=tabpanel]', sec).forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
    }));
  });

  /* ---------------- predictive search ---------------- */
  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  let pTimer;
  pInput && pInput.addEventListener('input', () => {
    clearTimeout(pTimer);
    const q = pInput.value.trim();
    if (q.length < 2) { pResults.innerHTML = ''; return; }
    pTimer = setTimeout(async () => {
      try {
        const url = `${A.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
        const data = await (await fetch(url)).json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        pResults.innerHTML = products.length
          ? `<p class="eyebrow">Products</p><div class="predict">${products.map((p) => `
              <a href="${p.url}">
                <div class="media" data-fit="cover" style="--r:${getComputedStyle(document.documentElement).getPropertyValue('--card-ratio').trim() || 0.8}">
                  ${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=360" alt="" loading="lazy" crossorigin="anonymous">` : ''}
                </div>${p.title.split(' — ')[0]}<br><span class="muted">${money(Math.round(parseFloat(p.price) * 100))}</span>
              </a>`).join('')}</div>`
          : '<p class="muted">No matches yet — press enter to search everything.</p>';
        initImages(pResults);
      } catch (e) { /* ignore */ }
    }, 220);
  });

  /* ---------------- cart ---------------- */
  const drawer = $('#CartDrawer');
  async function getCart() { return (await fetch(`${A.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json(); }

  function lineHTML(item) {
    const title = item.product_title.split(' — ')[0];
    const variant = item.product_has_only_default_variant ? '' : `<p class="small muted">${item.variant_title || ''}</p>`;
    const img = item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=240" alt="" crossorigin="anonymous">` : '';
    return `<div class="line" data-key="${item.key}">
      <a href="${item.url}" class="line__img"><div class="media" data-fit="auto" data-edge="x" style="--r:0.8">${img}</div></a>
      <div class="line__info">
        <a class="line__title" href="${item.url}">${title}</a>${variant}
        <div class="line__row">
          <div class="qty">
            <button type="button" class="qty__btn" data-line-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
            <input class="qty__input" type="number" value="${item.quantity}" min="0" data-line-input aria-label="Quantity">
            <button type="button" class="qty__btn" data-line-qty="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
          <button type="button" class="link-btn small" data-line-qty="0">Remove</button>
        </div>
      </div>
      <strong class="line__total">${money(item.final_line_price)}</strong>
    </div>`;
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!drawer) return;
    $('[data-cart-count-label]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    const items = $('[data-cart-items]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      items.innerHTML = `<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn" href="/collections/all">Start shopping</a></div>`;
      foot.hidden = true;
    } else {
      items.innerHTML = cart.items.map(lineHTML).join('');
      foot.hidden = false;
      $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    }
    const meter = $('[data-ship-meter]', drawer);
    if (A.freeShipping > 0 && cart.item_count) {
      const left = A.freeShipping - cart.total_price;
      meter.hidden = false;
      $('[data-ship-text]', meter).textContent = left > 0 ? `You're ${money(left)} away from free shipping` : "You've unlocked free shipping";
      $('[data-ship-bar]', meter).style.width = `${Math.min(100, (cart.total_price / A.freeShipping) * 100)}%`;
    } else meter.hidden = true;
    initImages(items);
  }

  async function openCart() {
    if (!drawer) { location.href = A.routes.cart; return; }
    openEl(drawer);
    renderCart(await getCart());
  }

  async function changeLine(key, quantity) {
    const res = await fetch(`${A.routes.cartChange}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    renderCart(await res.json());
  }
  drawer && drawer.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (!b) return;
    changeLine(b.closest('[data-key]').dataset.key, parseInt(b.dataset.lineQty, 10));
  });
  drawer && drawer.addEventListener('change', (e) => {
    if (!e.target.matches('[data-line-input]')) return;
    changeLine(e.target.closest('[data-key]').dataset.key, parseInt(e.target.value, 10) || 0);
  });

  /* ---------------- product page ---------------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root) || $('form[action*="/cart/add"]', root);
    const idInput = $('[data-variant-input]', root);
    const addBtn = $('[data-add-btn]', root);
    const errEl = $('[data-form-error]', root);
    const track = $('[data-track]', root);
    const counter = $('[data-slide-index]', root);
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const showMedia = (id, smooth = true) => {
      const slide = $(`#Media-${id}`, root);
      if (!slide) return;
      if (isDesktop()) {
        const y = slide.getBoundingClientRect().top + window.scrollY - 90;
        if (Math.abs(window.scrollY - y) > 40) window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
      $$('[data-thumb]', root).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };

    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    // Colour-filtered gallery. Media order convention: each variant's photos follow its
    // variant image; photos before the first variant image are shared by all colours.
    const slides = $$('.pdp__slide', root);
    const thumbs = $$('.pdp__thumbs li', root);
    const order = slides.map((sl) => sl.dataset.mediaId);
    const starts = [...new Set(data.variants.map((v) => v.media_id).filter(Boolean).map(String))]
      .map((id) => order.indexOf(id)).filter((i) => i >= 0).sort((a, b) => a - b);
    const groupOf = {};
    order.forEach((id, i) => {
      let g = 'shared';
      for (const st of starts) if (i >= st) g = order[st];
      groupOf[id] = g;
    });
    const canFilter = root.dataset.filterGallery === 'true' && starts.length >= 2 && order.length > 8;
    const showAllBtn = $('[data-show-all]', root);
    const total = $('[data-slide-total]', root);
    let filtered = false;
    const applyFilter = (mediaId, userPicked) => {
      if (!canFilter || !mediaId) return;
      const g = groupOf[String(mediaId)];
      if (!g) return;
      filtered = true;
      let n = 0;
      [slides, thumbs].forEach((list) => list.forEach((el) => {
        const eg = groupOf[el.dataset.mediaId];
        const show = eg === g || eg === 'shared';
        el.hidden = !show;
        el.style.order = userPicked && eg === g ? '-1' : '';
        if (show && list === slides) n++;
      }));
      if (total) total.textContent = n;
      if (counter) counter.textContent = 1;
      if (showAllBtn) showAllBtn.hidden = false;
      initImages(root);
    };
    showAllBtn && showAllBtn.addEventListener('click', () => {
      [...slides, ...thumbs].forEach((el) => { el.hidden = false; el.style.order = ''; });
      if (total) total.textContent = slides.length;
      showAllBtn.hidden = true; filtered = false;
    });

    // mobile slide counter
    track && counter && track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      counter.textContent = i + 1;
    }, { passive: true });

    // desktop: active thumb follows scroll
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && isDesktop()) {
            const id = en.target.dataset.mediaId;
            $$('[data-thumb]', root).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      $$('.pdp__slide', root).forEach((s) => io.observe(s));
    }

    // lightbox (full photo, never cropped)
    track && track.addEventListener('click', (e) => {
      const fr = e.target.closest('.zoomable');
      if (!fr) return;
      const img = $('img', fr);
      const src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2400');
      const lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.innerHTML = `<button class="icon-btn" type="button" aria-label="Close">✕</button><img src="${src}" alt="${img.alt || ''}">`;
      lb.addEventListener('click', () => lb.remove());
      document.body.appendChild(lb);
    });

    const selected = () => $$('[data-option-index]', root).map((fs) => {
      const c = $('input:checked', fs); return c ? c.value : null;
    });

    const update = (fromUser) => {
      const opts = selected();
      const v = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-index]', root).forEach((fs, i) => { const l = $('[data-option-label]', fs); if (l) l.textContent = opts[i] || ''; });
      // availability marks for other values given current selections
      $$('[data-option-index]', root).forEach((fs, i) => {
        $$('input[data-option-value]', fs).forEach((inp) => {
          const test = opts.slice(); test[i] = inp.value;
          const ok = data.variants.some((x) => x.available && x.options.every((o, j) => o === test[j]));
          const lab = inp.nextElementSibling; lab && lab.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      const pw = $('[data-price-wrap] [data-price]', root);
      if (pw) {
        pw.innerHTML = v.compare_at_price > v.price
          ? `<span class="price__now price__now--sale">${money(v.price)}</span><s class="price__was">${money(v.compare_at_price)}</s>`
          : `<span class="price__now">${money(v.price)}</span>`;
      }
      if (fromUser) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        if (v.media_id) { applyFilter(v.media_id, true); showMedia(v.media_id); }
      }
    };
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-value]')) update(true); });
    update(false);
    const initial = data.variants.find((x) => String(x.id) === idInput.value);
    const deepLinked = !!new URL(location.href).searchParams.get('variant');
    if (initial && initial.media_id) applyFilter(initial.media_id, deepLinked);
    if (initial && initial.media_id && deepLinked) setTimeout(() => showMedia(initial.media_id, false), 50);

    // qty
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      const inp = $('.qty__input', b.parentElement);
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    });

    // add to cart
    form && form.addEventListener('submit', async (e) => {
      if (!A.cartDrawer) return;
      e.preventDefault();
      errEl.hidden = true;
      addBtn.disabled = true;
      const label = addBtn.textContent; addBtn.textContent = 'Adding…';
      try {
        const res = await fetch(`${A.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const body = await res.json();
        if (!res.ok) throw new Error(body.description || body.message || 'Could not add to bag');
        await openCart();
      } catch (err) {
        errEl.textContent = err.message; errEl.hidden = false;
      } finally {
        addBtn.disabled = false; addBtn.textContent = label;
      }
    });

    // recently viewed
    try {
      const key = 'atelier:recent';
      const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== data.url);
      list.unshift(data.url);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 10)));
    } catch (e) { /* storage unavailable */ }
  });

  /* ---------------- recently viewed ---------------- */
  $$('[data-recent]').forEach(async (sec) => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('atelier:recent') || '[]'); } catch (e) { return; }
    const current = `/products/${sec.dataset.current}`;
    list = list.filter((u) => !u.endsWith(current)).slice(0, 4);
    if (!list.length) return;
    const cards = await Promise.all(list.map((u) => fetch(`${u}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    const html = cards.filter(Boolean).join('');
    if (!html) return;
    const grid = $('[data-recent-grid]', sec);
    grid.innerHTML = html;
    sec.hidden = false;
    initImages(grid);
  });

  /* ---------------- recommendations ---------------- */
  $$('[data-recs]').forEach(async (sec) => {
    try {
      const html = await (await fetch(sec.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recs]');
      if (inner && inner.innerHTML.trim()) { sec.innerHTML = inner.innerHTML; initImages(sec); }
    } catch (e) { /* ignore */ }
  });

  /* ---------------- collection ---------------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
    location.href = url;
  }));
  $$('[data-filter-form]').forEach((f) => {
    f.addEventListener('change', (e) => { if (e.target.type === 'checkbox' && window.matchMedia('(min-width: 990px)').matches) f.requestSubmit(); });
    f.addEventListener('submit', (e) => {
      // drop empty price inputs so they don't create empty filters
      $$('input[type=number]', f).forEach((i) => { if (i.value === '') i.disabled = true; });
    });
  });
  $$('[data-load-more]').forEach((btn) => btn.addEventListener('click', async (e) => {
    e.preventDefault();
    btn.textContent = 'Loading…';
    const loaded = btn.href;
    try {
      const html = await (await fetch(loaded)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-plp-grid]');
      const newGrid = doc.querySelector('[data-plp-grid]');
      const frag = document.createDocumentFragment();
      Array.from(newGrid.children).forEach((c) => frag.appendChild(c));
      grid.appendChild(frag);
      initImages(grid);
      const next = doc.querySelector('[data-load-more]');
      const wrap = btn.parentElement;
      if (next) { btn.href = next.href; btn.textContent = 'Show more'; wrap.querySelector('p') && (wrap.querySelector('p').textContent = next.parentElement.querySelector('p').textContent); }
      else wrap.remove();
      history.replaceState({}, '', loaded);
    } catch (err) { location.href = btn.href; }
  }));
  $$('[data-clamp-toggle]').forEach((b) => {
    const t = b.previousElementSibling;
    if (t.scrollHeight <= t.clientHeight + 2) { b.hidden = true; return; }
    b.addEventListener('click', () => { const o = t.classList.toggle('is-open'); b.textContent = o ? 'Read less' : 'Read more'; });
  });

  /* ---------------- init ---------------- */
  initImages();
  document.addEventListener('shopify:section:load', (e) => initImages(e.target));
})();
